import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import AscendingSvg from '../../Form/SortSvg/AscendingSvg';
import DescendingSvg from '../../Form/SortSvg/DescendingSvg';

import Swal from 'sweetalert2';
import { blockEmployer } from '../../../redux/actions/employer/blockEmployer';
import { useDispatch, useSelector } from 'react-redux';
import { resetBlockEmployer, resetBlockListEmployer, resetDeleteEmployer, resetDeleteListEmployer, setSortEmployerList } from '../../../redux/slices/employer.slice';
import { blockListEmployer } from '../../../redux/actions/employer/blockListEmployer';
import { deleteListEmployer } from '../../../redux/actions/employer/deleteListEmployer';
import { deleteEmployer } from '../../../redux/actions/employer/deleteEmployer';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function BlockedList({ currentItems, checked, setChecked, showAction, checkedAll, setCheckedAll, onStartFetch }) {
  const dispatch = useDispatch();
  const {
    blockEmployer: { data: blockEmployerData, error: blockEmployerError, loading: blockEmployerLoading },
    deleteEmployer: { data: deleteEmployerData, error: deleteEmployerError, loading: deleteEmployerLoading },
    blockListEmployer: { data: blockListEmployerData, error: blockListEmployerError, loading: blockListEmployerLoading },
    deleteListEmployer: { data: deleteListEmployerData, error: deleteListEmployerError, loading: deleteListEmployerLoading },
    sortEmployerList,
  } = useSelector((state) => state.employer);

  const handleUnBlock = (userId) => {
    Swal.fire({
      title: 'Вы действительно хотите разблокировать контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          blockEmployer({
            id: userId,
            is_blocked: false,
          }),
        );
      }
    });
  };
  useEffect(() => {
    if (blockEmployerData) {
      if (blockEmployerData?.is_blocked) {
      } else {
        Swal.fire({
          title: 'Учетная запись контрагента перемещена в блок "Не активные"',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });
      }
      dispatch(resetBlockEmployer());
      onStartFetch();
    }
  }, [blockEmployerData]);

  const handleDelete = (userId) => {
    Swal.fire({
      title: 'Вы действительно хотите удалить контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteEmployer({
            id: userId,
          }),
        );
      }
    });
  };
  useEffect(() => {
    if (deleteEmployerData) {
      Swal.fire({
        title: 'Учетная запись удалена',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetDeleteEmployer());
      onStartFetch();
    }
  }, [deleteEmployerData]);

  const handleUnBlockList = () => {
    Swal.fire({
      title: 'Вы действительно хотите разблокировать выбраных контрагентов?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          blockListEmployer({
            employers: Object.keys(checked)
              ?.filter((key) => checked[key])
              .map((key) => key),
            is_blocked: false,
          }),
        );
      }
    });
  };
  useEffect(() => {
    if (blockListEmployerData) {
      Swal.fire({
        title: 'Учетные записи контрагентов перемещены в блок "Не активные"',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetBlockListEmployer());
      onStartFetch();
    }
  }, [blockListEmployerData]);

  const handleDeleteList = () => {
    Swal.fire({
      title: 'Вы действительно хотите удалить выбраных контрагентов?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteListEmployer({
            employers: Object.keys(checked)
              ?.filter((key) => checked[key])
              .map((key) => key),
            is_active: false,
          }),
        );
      }
    });
  };
  useEffect(() => {
    if (deleteListEmployerData) {
      Swal.fire({
        title: 'Учетные записи удалены',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetDeleteListEmployer());
      onStartFetch();
    }
  }, [deleteListEmployerData]);

  return (
    <table className=" divide-y divide-gray-200 overflow-auto">
      <thead>
        <tr>
          <th scope="col" className=" py-3 text-start text-[16px] font-medium uppercase min-w-[27px] pr-2">
            <input
              id="select_all"
              name="all"
              type="checkbox"
              aria-checked={false}
              className="h-3 w-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
              onChange={(e) => {
                setCheckedAll(e.target.checked);
              }}
              checked={checkedAll}
              defaultChecked={checkedAll}
            />
          </th>
          <th scope="col" className="pr-2 py-3 text-start text-[14px] font-medium hidden md:table-cell px-2">
            <div
              className="flex flex-row items-center gap-2 cursor-pointer min-w-[50px]"
              id="id"
              onClick={() => {
                dispatch(setSortEmployerList(!sortEmployerList));
              }}>
              ID
              {!sortEmployerList ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" />}
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-start text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="title">
              Наименование
            </div>
          </th>
          {/* <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
                        <div className='flex flex-row items-center gap-2 cursor-pointer' id='active' >
                            Активных
                            {
                                sortTypeState === 'active' ? 
                                    sortDirectionState ?
                                        <AscendingSvg color="#000000" />
                                        :
                                        <DescendingSvg color="#000000" />
                                    : ''
                            }
                        </div>
                    </th>
                    <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
                        <div className='flex flex-row items-center gap-2 cursor-pointer' id='moderation' >
                            На модерации
                            {
                                sortTypeState === 'moderation' ? 
                                    sortDirectionState ?
                                        <AscendingSvg color="#000000" />
                                        :
                                        <DescendingSvg color="#000000" />
                                    : ''
                            }
                        </div>
                    </th>
                    <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
                        <div className='flex flex-row items-center gap-2 cursor-pointer' id='inactive' >
                            Не активных
                            {
                                sortTypeState === 'inactive' ? 
                                    sortDirectionState ?
                                        <AscendingSvg color="#000000" />
                                        :
                                        <DescendingSvg color="#000000" />
                                    : ''
                            }
                        </div>
                    </th>
                    <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
                        <div className='flex flex-row items-center gap-2 cursor-pointer' id='delete' >
                            Удалены
                            {
                                sortTypeState === 'delete' ? 
                                    sortDirectionState ?
                                        <AscendingSvg color="#000000" />
                                        :
                                        <DescendingSvg color="#000000" />
                                    : ''
                            }
                        </div>
                    </th> */}
          <th scope="col" className="pl-2 py-1 text-start text-[14px] font-medium">
            {
              showAction ? (
                <Menu as="div" className="relative inline-block text-left">
                  <div>
                    <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                      Действия
                      <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                    </Menu.Button>
                  </div>

                  <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              onClick={() => {
                                handleUnBlockList();
                              }}
                              className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                              Разблокировать
                            </Link>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <Link onClick={handleDeleteList} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                              Удалить
                            </Link>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              ) : (
                ''
              )
              // <button
              //     className='flex w-fit p-2 text-sm text-gray-800 bg-[#E5E5E5] border-1 border-[#C4C4C4] rounded-md'
              //     onClick={handleUnBlock}
              // >
              //     Разблокировать
              // </button>: ''
            }
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 items-center justify-center align-middle">
        {currentItems &&
          currentItems.map((item) => (
            <tr key={item.num}>
              <td className="pr-2 py-4 whitespace-nowrap text-sm text-gray-800 pr-2">
                <input
                  name={item.num}
                  type="checkbox"
                  checked={checked?.[item?.num]}
                  defaultChecked={checked?.[item?.num]}
                  onChange={(e) => {
                    setChecked((prev) => ({ ...prev, [item.num]: e.target.checked }));
                  }}
                  className="select_checkbox h-3 w-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                />
              </td>
              <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 hidden md:table-cell">{item.num}</td>
              <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800">
                <p className="block md:hidden">{item.num}</p>
                <Link to={`/user/${item.num}`}>
                  {item.name}
                  <br />
                  <span className="inline-block text-gray-400 text-xs -translate-y-[2px]">{item.email}</span>
                </Link>
              </td>
              {/* <td className='px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800'>
                                { item.active }
                            </td>
                            <td className='px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800'>
                                { item.moderation }
                            </td>
                            <td className='px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800'>
                                { item.inactive }
                            </td>
                            <td className='px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800'>
                                { item.delete }
                            </td> */}
              <td className="pl-2 py-2 whitespace-nowrap text-sm text-gray-800">
                <button
                  onClick={() => {
                    handleUnBlock(item.num);
                  }}
                  className="flex w-fit p-2 text-sm text-gray-800 bg-[#E5E5E5] border-1 border-[#C4C4C4] rounded-md">
                  Разблокировать
                </button>
              </td>{' '}
              <td className="pl-2 py-2 whitespace-nowrap text-sm text-gray-800">
                <button
                  onClick={() => {
                    handleDelete(item.num);
                  }}
                  className="flex w-fit p-2 text-sm text-gray-800 bg-[#E5E5E5] border-1 border-[#C4C4C4] rounded-md">
                  Удалить
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default BlockedList;
